import { useId, useState, type ReactNode } from "react";
import "./Accordion.scss";

type AccordionProps = {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  count?: number;
  icon?: ReactNode;
};

export function Accordion({
  title,
  children,
  defaultOpen = false,
  count,
  icon,
}: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const triggerID = useId();
  const contentID = useId();

  return (
    <section className={`accordion ${open ? "accordion--open" : ""}`}>
      <button
        className="accordion-trigger"
        id={triggerID}
        type="button"
        aria-expanded={open}
        aria-controls={contentID}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="accordion-icon-cell" aria-hidden="true">
          {icon}
        </span>
        <span className="accordion-title">{title}</span>
        <span className="accordion-count-cell">
          {count !== undefined && (
            <span className="accordion-count">{count}</span>
          )}
        </span>
        <span className="accordion-chevron" aria-hidden="true">
          <svg
            aria-hidden="true"
            className="accordion-chevron-icon"
            viewBox="0 0 24 24"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </span>
      </button>
      {open && (
        <div
          aria-labelledby={triggerID}
          className="accordion-content"
          id={contentID}
          role="region"
        >
          {children}
        </div>
      )}
    </section>
  );
}
